import React, { FunctionComponent } from 'react';
import { getTagAttributes } from '../../../helpers/html.utils';
import { IHtmlTag } from '../../../models/common/metadata-tagging/html-tag.model';

type MasterBodyEndProps = {
  bodyEnd: IHtmlTag[];
};

export const MasterBodyEnd: FunctionComponent<MasterBodyEndProps> = (props: MasterBodyEndProps) => {
  return (
    <>
      {/* Body End Scripts */}
      {props.bodyEnd?.map((script) => {
        if (script.innerHtml) return <script {...getTagAttributes(script.attributes)}>{script.innerHtml}</script>;
        else return <script {...getTagAttributes(script.attributes)} />;
      })}
    </>
  );
};

export default MasterBodyEnd;
